/* global axios */
import ApiClient from './ApiClient';

// Agente de IA: o backend do Atende fala com o motor; a tela nunca ve a chave de frota.
class AgenteIaAPI extends ApiClient {
  constructor() {
    super('agente_ia', { accountScoped: true });
  }

  status() {
    return axios.get(`${this.url}/status`);
  }

  personas() {
    return axios.get(`${this.url}/personas`);
  }

  persona(id) {
    return axios.get(`${this.url}/personas/${id}`);
  }

  atualizarPersona(id, attrs) {
    return axios.patch(`${this.url}/personas/${id}`, attrs);
  }

  habilidades(personaId) {
    return axios.get(`${this.url}/personas/${personaId}/habilidades`);
  }

  salvarHabilidades(personaId, attrs) {
    return axios.put(`${this.url}/personas/${personaId}/habilidades`, attrs);
  }

  caixas() {
    return axios.get(`${this.url}/caixas`);
  }

  ligarCaixa(inboxId, personaId, substituirBot = false) {
    return axios.put(`${this.url}/caixas/${inboxId}`, {
      persona_id: personaId,
      substituir_bot: substituirBot,
    });
  }

  portaoDaCaixa(inboxId, portao) {
    return axios.put(`${this.url}/caixas/${inboxId}`, { portao });
  }

  testar({ mensagem, threadId, arquivo, reais = false }) {
    if (arquivo) {
      const dados = new FormData();
      dados.append('arquivo', arquivo);
      if (threadId) dados.append('thread_id', threadId);
      return axios.post(`${this.url}/testar`, dados);
    }
    return axios.post(`${this.url}/testar`, {
      mensagem,
      thread_id: threadId,
      reais,
    });
  }

  operador() {
    return axios.get(`${this.url}/operador`);
  }

  // dados: { motor, aplicar, regras, etapas: [{ id, description }] } (so o que mudou)
  salvarOperador(dados) {
    return axios.put(`${this.url}/operador`, dados);
  }

  sugerirFrases() {
    return axios.post(`${this.url}/operador/sugerir`);
  }

  observarCaixa(inboxId, ligado) {
    return axios.put(`${this.url}/operador/caixas/${inboxId}`, { ligado });
  }

  sessoesDeTeste() {
    return axios.get(`${this.url}/testar/sessoes`);
  }

  bases() {
    return axios.get(`${this.url}/bases`);
  }

  criarBase(attrs) {
    return axios.post(`${this.url}/bases`, attrs);
  }

  documentos(baseId) {
    return axios.get(`${this.url}/bases/${baseId}/documentos`);
  }

  enviarDocumento(baseId, { titulo, texto, arquivo }) {
    if (arquivo) {
      const dados = new FormData();
      dados.append('arquivo', arquivo);
      return axios.post(`${this.url}/bases/${baseId}/documentos`, dados);
    }
    return axios.post(`${this.url}/bases/${baseId}/documentos`, {
      titulo,
      texto,
    });
  }

  documento(id) {
    return axios.get(`${this.url}/documentos/${id}`);
  }

  atualizarDocumento(id, { titulo, texto }) {
    return axios.patch(`${this.url}/documentos/${id}`, { titulo, texto });
  }

  apagarDocumento(id) {
    return axios.delete(`${this.url}/documentos/${id}`);
  }

  avisos() {
    return axios.get(`${this.url}/avisos`);
  }

  criarAviso(attrs) {
    return axios.post(`${this.url}/avisos`, attrs);
  }

  atualizarAviso(id, attrs) {
    return axios.put(`${this.url}/avisos/${id}`, attrs);
  }

  apagarAviso(id) {
    return axios.delete(`${this.url}/avisos/${id}`);
  }

  aprovacoes() {
    return axios.get(`${this.url}/bases/aprovacoes`);
  }

  decidirAprovacao(id, aprovar) {
    return axios.post(`${this.url}/bases/aprovacoes/${id}`, { aprovar });
  }

  chaves() {
    return axios.get(`${this.url}/chaves`);
  }

  criarChave(attrs) {
    return axios.post(`${this.url}/chaves`, attrs);
  }

  apagarChave(id) {
    return axios.delete(`${this.url}/chaves/${id}`);
  }

  usarChave(id, model) {
    return axios.post(`${this.url}/chaves/${id}/usar`, model ? { model } : {});
  }

  testarChave(id) {
    return axios.post(`${this.url}/chaves/${id}/testar`);
  }

  conversas(params) {
    return axios.get(`${this.url}/conversas`, { params });
  }

  devolverConversa(id) {
    return axios.post(`${this.url}/conversas/${id}/devolver`);
  }

  custo(mes) {
    return axios.get(`${this.url}/custo`, { params: mes ? { mes } : {} });
  }

  claude() {
    return axios.get(`${this.url}/claude`);
  }

  novoTokenClaude() {
    return axios.post(`${this.url}/claude/rotate`);
  }

  montagem() {
    return axios.get(`${this.url}/montagem`);
  }

  montar(montagem) {
    return axios.put(`${this.url}/montagem`, { montagem });
  }

  // Tamanho das instrucoes que a montagem escreveria, sem gravar nada.
  previaMontagem(montagem) {
    return axios.post(`${this.url}/montagem/previa`, { montagem });
  }

  prompt(personaId) {
    return axios.get(`${this.url}/prompt`, {
      params: personaId ? { persona_id: personaId } : {},
    });
  }

  oferta() {
    return axios.get(`${this.url}/oferta`);
  }

  pedidos() {
    return axios.get(`${this.url}/pedidos`);
  }

  pedir(tipo, valor) {
    return axios.post(`${this.url}/pedidos`, { pedido: { tipo, valor } });
  }
}

export default new AgenteIaAPI();
